"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AppAuthorization = _interopRequireDefault(require("./components/AppAuthorization.vue"));
var _PlatformConfig = _interopRequireDefault(require("./components/PlatformConfig.vue"));
var _CallbackLogs = _interopRequireDefault(require("./components/CallbackLogs.vue"));
var _TemplateManagement = _interopRequireDefault(require("./components/TemplateManagement.vue"));
var _ReleasePreparation = _interopRequireDefault(require("./components/ReleasePreparation.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WechatOpenPlatform',
  components: {
    AppAuthorization: _AppAuthorization.default,
    PlatformConfig: _PlatformConfig.default,
    TemplateManagement: _TemplateManagement.default,
    ReleasePreparation: _ReleasePreparation.default,
    CallbackLogs: _CallbackLogs.default
  },
  data: function data() {
    return {
      activeTab: 'authorization'
    };
  }
};